import React, { Fragment, useContext, useRef } from 'react';

// contexts
import { UserContext } from "../../Contexts/UserContext/UserContext.js";
import SwapBotContext from '../../Contexts/SwapBotContext.js';
// hooks
import useLog from '../../hooks/useLog.js';
import useTxSender, { reload_token_balance_andHistory } from '../../hooks/useTxSender.js';
// components
import { Row } from "../../components/Row";
import { Spaces } from "../../components/Spaces";
import { TextDisplay } from "../../components/TextDisplay/TextDisplay";
import { Tableau } from "../../components/Tableau";
import SoldeBSV from '../../components/SoldeBSV.js';
import SuccessTxSender from '../../components/SuccessTxSender.js';
import SoldeToken from '../../components/SoldeToken.js';
// other
import { getLog, tryAccessProperty } from "../../helpers/helpers.js"
import { default_func_jsx_fail } from '../../helpers/helpers.js';
import { MouseOverPopover } from '../../components/MouseOverPopover.js';


/**
 * converts a list of admin_requests to table_values ready to inject in a Tableau component
 * 
 * args: 
 * 		- admin_requests: 			list
 * 		- send_tokens_to_user		func
 * 		- refund_bsv_to_user		func
 */
function admin_requests_to_table_values(
	admin_requests, dict_sell_button_style, send_tokens_to_user, refund_bsv_to_user
) {
	const function_id = "admin_requests_to_table_values(): "
	const log = getLog(function_id)
	let table_values = []

	if (admin_requests && admin_requests.length > 0) {
		for (let i = 0; i < admin_requests.length; i++) {
			// need const to avoid "no-loop-func" warning/errors as we call tryAccessProperty() with it
			const admin_request = admin_requests[i]

			// date

			var date_unset = "inconnue"

			var timestamp = tryAccessProperty(() => admin_request.caller.caller.oracle_Timestamp.value, date_unset)
			var date = date_unset
			if (timestamp && !isNaN(timestamp)) {
				date = new Date(timestamp).toLocaleString("fr-FR", { hour12: false })
			}

			// total_EUR_paid

			// var total_EUR_paid = admin_request.get_total_EUR_paid()
			var total_EUR_paid = admin_request.paid_tokens_price_EUR  // should be with or without 1% fee ?
			var total_EUR_paid_jsx = (total_EUR_paid).toFixed(2) + " €"

			// bsveur

			var bsveur_jsx = (admin_request.BSVEUR_oracle).toFixed(2) + " €"

			// nb_tokens

			var nb_tokens_basePrice = admin_request.expected_nb_tokens_base_price
			// var nb_tokens_secondaryPrice = (total_EUR_paid - nb_tokens_basePrice * admin_request.paid_base_price) / admin_request.paid_secondary_price
			var nb_tokens_secondaryPrice = admin_request.expected_nb_tokens_secondary_price

			// safety check because we have some cases where we get a -0.01xxx value or similar
			// update: should not happen anymore with updated contracts
			if (nb_tokens_secondaryPrice < 0) {
				log("warning negative nb_tokens_secondaryPrice=", nb_tokens_secondaryPrice, " => setting at 0")
				nb_tokens_secondaryPrice = 0
			}
			/*
			// BEWARE this only works if we prevent buying/selling decimals tokens
			// safety check for cases were we have +0.01xxx or similar
			var decimals_nb_tokens_secondaryPrice = nb_tokens_secondaryPrice - parseInt(nb_tokens_secondaryPrice)
			if(decimals_nb_tokens_secondaryPrice > 0){
				log("warning decimals nb_tokens_secondaryPrice=",nb_tokens_secondaryPrice,
					" => setting at",parseInt(nb_tokens_secondaryPrice))
				nb_tokens_secondaryPrice = parseInt(nb_tokens_secondaryPrice)
			}
			*/

			const nb_tokens = nb_tokens_basePrice + nb_tokens_secondaryPrice

			log("admin_request=", admin_request,
				"\n total_EUR_paid=", total_EUR_paid,
				"\n nb_tokens_basePrice=", nb_tokens_basePrice,
				"\n nb_tokens_secondaryPrice=", nb_tokens_secondaryPrice,
				"\n paid_base_price_EUR=", admin_request.paid_base_price_EUR,
				"\n paid_secondary_price_EUR=", admin_request.paid_secondary_price_EUR,
				"\n nb_tokens=", nb_tokens,
				"\n location=", admin_request.location)

			// status_jsx

			var status = admin_request.status
			var status_url_location = admin_request.location // default, better than nothing
			var status_jsx = status

			var is_completed = false
			if (status !== "pending") {
				is_completed = true
			}

			// translate status
			if (status === "paid") {
				status_jsx = "payé"
				// TODO get url pointing to payment tx
			}
			else if (status === "refunded") {
				status_jsx = "remboursé"
				// get url pointing to refund tx
				if (admin_request.BSV_Refund) {
					status_url_location = admin_request.BSV_Refund.location
				}
			}
			else if (status === "pending") {
				status_jsx = "en attente"
			}

			var status_url = "https://whatsonchain.com/tx/" + status_url_location.split('_')[0]
			status_jsx =
				<a href={status_url} target="_blank" rel="noopener noreferrer" style={{ color: (is_completed ? "limegreen" : "orange") }}>
					{status_jsx}
				</a>

			// timestamp_completed / admin actions

			var timestamp_completed = (admin_request.cancel_timestamp || admin_request.paid_timestamp)

			var date_completed = date_unset
			var admin_actions = "--"
			if (is_completed) {
				date_completed = new Date(timestamp_completed).toLocaleString("fr-FR", { hour12: false })
			}
			else { // status==="pending"
				const request_location = admin_request.location // react needs this because of unsafe references
				admin_actions =
					<Fragment>
						<button onClick={() => { send_tokens_to_user(request_location, nb_tokens) }}
							style={{ ...dict_sell_button_style, marginRight: "5px" }}
							className="button-main-style-red">
							Payer {nb_tokens} tokens
						</button>
						<button onClick={() => { refund_bsv_to_user(request_location) }}
							className="blue-button-main-style"
							style={dict_sell_button_style}>
							Rembourser {total_EUR_paid}€ de BSV
						</button>
					</Fragment>
			}

			// "Date", "Tokens", "Prix", "BSV/EUR", "Status", "Date"/"Actions"
			var curr_data = [
				String(date),
				String(parseInt(nb_tokens)),
				total_EUR_paid_jsx,
				bsveur_jsx,
				status_jsx,
				(is_completed ? date_completed : admin_actions)
			]
			table_values.push(curr_data)
		}
	}
	return table_values
}


export function Slide_SwapBot_Achats(props) {
	const function_id = "Slide_SwapBot_Achats(): "
	// const classname = function_id
	const log = useLog(function_id)

	const tokenName = "Delphe"
	const tokenName_plural = tokenName + 's'

	// update delphetx_state based on txStateContext
	const tokenID = userContext.get_selected_coin_props().tokenid
	const tokenActionID = tokenID + "_admin_send_bought_tokens_or_refund" // todo make better, will need a dynamic one with txid in it for parallel sends

	const swapbotContext = useContext(SwapBotContext)
	const admin_buy_requests = swapbotContext.admin_buy_requests
	const base_price = swapbotContext.base_price
	const secondary_price = swapbotContext.secondary_price

	let admin_buy_requests_pending = null, admin_buy_requests_completed = null
	if (admin_buy_requests != null) {
		admin_buy_requests_pending = admin_buy_requests.filter(e => e.get_status().includes("pending"))
		admin_buy_requests_completed = admin_buy_requests.filter(e => !e.get_status().includes("pending"))
	}

	log("\n admin_buy_requests.length=", admin_buy_requests ? admin_buy_requests.length : null,
		"\n admin_buy_requests_pending=", admin_buy_requests_pending,
		"\n admin_buy_requests_completed=", admin_buy_requests_completed,
	)

	const userContext = useContext(UserContext)
	const token_balance = userContext.tokens_balance[tokenID]
	const bool_context_has_loaded = (
		token_balance != null && admin_buy_requests != null && base_price != null && secondary_price != null
	)
	const has_loaded = (admin_buy_requests != null)

	const ref_messageEndRef = useRef(null) // for autoscroll

	// --- FUNCTIONS ---

	async function func_empty_fields() { }
	const mess_default = "" //"Un récapitulatif des "+tokenName_plural+" à vendre va s'afficher ici"
	var jsx_loading = null //<LoaderWithMess mess={mess_default} />
	var jsx_recap = null

	const func_jsx_sending = (txstate) => {
		let sending_mess = null

		if (txstate['type'] === "refund") {
			sending_mess = <span> Remboursement des BSV en cours... </span>
		} else {
			let nbtokens = txstate.nbtokens // we had issue with it being undefined so let's check
			if (nbtokens) nbtokens = nbtokens.toFixed(2)
			else nbtokens = "undefined"
			sending_mess = <span>
				Sending {nbtokens} {tokenName_plural}...
			</span>
		}

		return (
			<Fragment>
				{sending_mess}&nbsp;
				<i className="reloadIcon fas fa-sync fa-spin" />
			</Fragment>
		)
	}

	const func_jsx_success = (txstate) => {
		let success_mess = <span>
			{txstate.nbtokens} {tokenName_plural} envoyés avec succès !
		</span>

		if (txstate['type'] === "refund") {
			success_mess = <span> BSV remboursés avec succès ! </span>
		}

		return (
			<SuccessTxSender txstate={txstate}>
				{success_mess}
			</SuccessTxSender>
		)
	}

	const func_onSuccess_once = () => {
		reload_token_balance_andHistory(userContext)
		swapbotContext.refresh_admin_buy_requests()
	}

	// --- HOOK useTxSender ---

	const array_bool_user_inputs = []

	const [
		bool_broadcast_lock,
		, // func_resetMess is useless in this slide
		dict_sell_button_style, // to use on all send buttons in this slide
		jsx_mess,
	]
		= useTxSender(
			tokenActionID,
			array_bool_user_inputs,
			bool_context_has_loaded,
			ref_messageEndRef,
			mess_default,
			jsx_loading,
			jsx_recap,
			func_jsx_sending,
			func_jsx_success,
			default_func_jsx_fail,
			func_empty_fields,
			func_onSuccess_once,
		)

	// --- FUNCTIONS ---

	function send_tokens_to_user(request_txid, nb_tokens_to_send) {
		// don't allow parallel sends
		if (bool_broadcast_lock) {
			window.alert("Echec: une demande est déjà en cours d'envoi.")
			return
		}
		swapbotContext.send_tokens_to_user(tokenActionID, tokenName, request_txid, nb_tokens_to_send)
	}

	function refund_bsv_to_user(request_location) {
		// don't allow parallel sends
		if (bool_broadcast_lock) {
			window.alert("Echec: une demande est déjà en cours d'envoi.")
			return
		}
		swapbotContext.refund_bsv_to_user(tokenActionID, tokenName, request_location)
	}

	// --- DISPLAY ---

	function _admin_requests_to_table_values(requests) {
		// inject required args
		return admin_requests_to_table_values(requests,
			dict_sell_button_style,
			send_tokens_to_user, refund_bsv_to_user
		)
	}

	let table_values = []
	if (admin_buy_requests_pending) {
		// reverse to display oldest first
		table_values = _admin_requests_to_table_values(admin_buy_requests_pending.reverse())
	}

	let table_values_completed = []
	if (admin_buy_requests_completed) {
		// no reverse to display newest first
		table_values_completed = _admin_requests_to_table_values(admin_buy_requests_completed)
	}

	const actions_title_jsx =
		<span style={{ display: "inline-flex" }}>
			Actions &nbsp;
			<MouseOverPopover
				contentjsx={<i className="fas fa-question-circle" />}
				popoverjsx={<Fragment>
					<b>Payer Tokens</b> envoie les {tokenName_plural} au cours BSV/EUR lors de la demande<br />
					<b>Rembourser</b> rembourse les BSV au client<br />
				</Fragment>}
			/>
		</span>

	return (
		<div>
			<h1><i className="fas fa-shopping-cart" /><Spaces count="3" />
				Demandes d'achats
			</h1><br />

			<center>
				<SoldeToken />
				<br />
				<SoldeBSV />
				<br />
			</center>

			<Row>
				<h3 style={{ paddingRight: "10px" }}><i className="fas fa-clock" /><Spaces count="3" />
					Achats en attente
				</h3>
				{/* <div style={{margin:"13px"}}>
						<button onClick={this.sendAll} className="button-main-style-red"
							style={buy_all_style} >Envoyer Tout</button>  
					</div>
				*/}
			</Row>

			<center>
				<div ref={ref_messageEndRef}>
					{/* note: seems like the ref only works if it's NOT in some conditional rendering */}
					{jsx_mess ?
						<Row><TextDisplay>
							{jsx_mess}
						</TextDisplay></Row>
						: null}
				</div>
			</center>

			{/* <Alert variant="light">
				<i style={{fontSize:"25px", marginRight: "10px"}} className="fa fa-info-circle" />
				Actions:<br/>
				<b>Payer Tokens</b> envoie les {tokenName_plural} au cours BSV/EUR lors de la demande<br/>
				<b>Rembourser</b> rembourse les BSV au client<br/>
			</Alert>
			<br/> */}

			<Tableau
				titles={["Date", tokenName_plural, "Prix", "BSV/EUR", "Status", actions_title_jsx]}
				values={table_values}
				empty_mess="Aucune demande en attente pour le moment."
				loading={!has_loaded}
			/>
			<br /><br /><br />

			<Row>
				<h4 style={{ paddingRight: "10px" }}>
					<i className="fas fa-clipboard-check" /><Spaces count="3" />
					Demandes d'achats complétées
				</h4>
			</Row>

			<Tableau
				titles={["Date", tokenName_plural, "Prix", "BSV/EUR", "Status", "Payé le"]}
				values={table_values_completed}
				empty_mess="Aucune demande complétée pour le moment."
				loading={!has_loaded}
			/>

		</div>
	)
}
